import React, { FC } from 'react'
import { LxHandleKeyDown } from '@src/utils/Accessbility'
import { LxLoadingSpinner } from '@components/loader/loadingSpinner.tsx'

type LxSaveButtonProps = {
  onSubmit: () => void
  label?: string
  classNames?: string
  tabIndex?: number
  isSubmitting?: boolean
  ariaLabel?: string
  role?: string
  disabled?: boolean
}

const LxSaveButton: FC<LxSaveButtonProps> = ({ 
  onSubmit, label = 'Save', 
  classNames = '', 
  tabIndex = 0, 
  isSubmitting = false, 
  ariaLabel = '', 
  role = 'button', 
  disabled = false 
}) => {
  const isDisabled = isSubmitting || disabled

  return (
    <div
      className={`${classNames.replace(/,/g, ' ')} ${isDisabled ? 'disabledButton' : ''}`}
      onClick={!isDisabled ? onSubmit : undefined}
      tabIndex={isDisabled ? -1 : tabIndex}
      onKeyDown={!isDisabled ? (event) => LxHandleKeyDown(event, onSubmit) : undefined}
      aria-label={ariaLabel}
      aria-disabled={isDisabled}
      role={role}
    >
      {isSubmitting ? <LxLoadingSpinner /> : <span>{label}</span>}
    </div>
  )
}

export default LxSaveButton
